import { ThemeOptions, alpha } from "@mui/material/styles"

import { amber, blue, green, neutral, red, purple } from "@constants/colors"

import { ThemeProps } from "./types"

export const palette = ({ darkMode }: ThemeProps): ThemeOptions["palette"] => {
  return {
    mode: darkMode ? "dark" : "light",
    primary: {
      main: darkMode ? neutral.white : neutral[900],
      light: darkMode ? neutral[200] : neutral[600],
      dark: darkMode ? neutral[400] : neutral[800],
      contrastText: darkMode ? neutral.black : neutral.white,
    },
    secondary: {
      main: darkMode ? neutral[300] : neutral[700],
      light: darkMode ? neutral[200] : neutral[600],
      dark: darkMode ? neutral[400] : neutral[800],
      contrastText: darkMode ? neutral.black : neutral.white,
    },
    error: {
      main: red[500],
      light: red[400],
      dark: red[600],
      contrastText: neutral.white,
    },
    warning: {
      main: amber[500],
      light: amber[400],
      dark: amber[600],
      contrastText: neutral.black,
    },
    info: {
      main: blue[500],
      light: blue[400],
      dark: blue[600],
      contrastText: darkMode ? neutral.white : neutral.black,
    },
    success: {
      main: green[500],
      light: green[400],
      dark: green[600],
      contrastText: darkMode ? neutral.white : neutral.black,
    },
    text: {
      primary: darkMode ? neutral.white : neutral[900],
      secondary: darkMode ? neutral[400] : neutral[600],
      disabled: darkMode ? neutral[600] : neutral[400],
    },
    background: {
      default: darkMode ? neutral[900] : neutral[50],
      paper: darkMode ? neutral[800] : neutral.white,
    },
    divider: darkMode ? alpha(neutral.white, 0.05) : alpha(neutral.black, 0.05),
    opacity: {
      helper: 0.5,
      disabled: 0.25,
    },
    tabFocus: darkMode ? purple[400] : purple[600],
  }
}
